// Header.js
import React, {Component} from 'react';
import ReactTable from "react-table";
import { CSVLink } from "react-csv";
import Modal from 'react-modal';
import 'react-table/react-table.css'
import 'react-dropdown/style.css';
import DateTimePicker from 'react-datetime-picker';

var moment = require('moment');

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    width                 : '400px',
    color                 : 'black'
  },
  overlay: {zIndex: 1000}
};

const printModalStyle = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    width                 : '500px',
    color                 : 'black'
  },
  overlay: {zIndex: 1000}
};

const cancelButton = {
  content : {
    float                 : 'right'  
  }
};

var date = new Date();

class BillingReport extends Component {

    constructor(props) {
        super(props);        
            this.state = {
            billingitems: [],
            cl_id: typeof(localStorage.getItem('headerClientId')) === 'undefined' ? 0 : localStorage.getItem('headerClientId'),
            us_id: localStorage.getItem('usId'),
            sortOptions: [{ id: 'pr_id', desc: true }],
            startDate: null,
            endDate: null,
            userToken: localStorage.getItem('userToken')
        };
       
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.filterReport = this.filterReport.bind(this);

    }

    openModal() {
      this.setState({modalIsOpen: true});
      if (this.state.cl_id =='') {
        this.setState({modalMessage: 'Please select a client first. '});
      } 

    }

    afterOpenModal() {     
    }

    closeModal() {
      this.setState({modalIsOpen: false});
    }

    filterReport = (url) => {
      this.getBilling(process.env.REACT_APP_NODE_ROOT_URL+'/reports/billing/'+this.state.cl_id);     
    }

    getBilling = (url) => {
      
     //Left of here with creating billing report
      
      let _startdate = moment(this.state.startDate).format("YYYY-MM-DD HH:mm");
      let _enddate = moment(this.state.endDate).format("YYYY-MM-DD HH:mm");
      
      var productJSON = JSON.stringify({
        cl_id: this.state.cl_id,
        pr_id: 0,
        start_date: _startdate,
        end_date: _enddate
      });

      console.log('logging billing json...');
      console.log(productJSON);      
      
      
      fetch(url, {
            method: 'post',        
            body: productJSON,      
            headers: {            
            'Content-Type': 'application/json',
            'bwToken': this.state.userToken
        }             
      }).then(res => res.json())
        .then(billingitems => this.setState({ billingitems }));       
      
    
    }  
    /*

    ranges: {
      'Today': [moment(), moment()],
      'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      'Last 7 Days': [moment().subtract(6, 'days'), moment()],
      'Last 30 Days': [moment().subtract(29, 'days'), moment()],
      'This Month': [moment().startOf('month'), moment().endOf('month')],
      'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  },
    */
    
    componentDidMount() {
      Modal.setAppElement('#main');
      //this.getBilling(process.env.REACT_APP_NODE_ROOT_URL+'/reports/billing/'+this.state.cl_id);          
    }
 
    render(){
        
        const { billingitems } = this.state;
        
        return (
        <div id="main">
        <div className="page-wrapper">
                <div className="row page-titles">
      
                  <div className="col-md-11 align-self-center">
                       <h3 className="text-primary">Shipment Billing Report</h3>                     
                  </div>
                  <div className="col-md-1 align-self-center"> 
                  
                  </div>
                </div>

                <div className="container-fluid">

                <div className="row">

                <div className="col-lg-12">
                    Select a Start and End Date for the report to see results.
                            <table>                              
                              <tbody>
                              <tr>
                                  <td>
                                    Start Date:<br />
                                    <DateTimePicker
                                      disableClock={true}
                                      onChange={startDate => {
                                        this.setState({ startDate });
                                      }}
                                      value={this.state.startDate}
                                      format={"MM-dd-y hh:mm a"}
                                    />
                                    &nbsp;&nbsp;
                                  </td>
                                  <td>
                                    End Date:<br />
                                    <DateTimePicker
                                      disableClock={true}
                                      onChange={date => {
                                        if (date) {
                                          // Set the time to 11:59:00 PM
                                          const updatedDate = new Date(date);
                                          updatedDate.setHours(23, 59, 0, 0);
                                          this.setState({ endDate: updatedDate }, () => {
                                            this.filterReport(); // Call filterReport only when endDate changes
                                          });
                                        }
                                      }}
                                      value={this.state.endDate}
                                      format={"MM-dd-y hh:mm a"}
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                           <br/>
                            <div className="card-body" name="card-order-list">
                            <CSVLink data={billingitems}>Download CSV of Shipment Billing</CSVLink>
                                <div className="table-responsive">
                                  <ReactTable
                                      data={billingitems}
                                      sorted={this.state.sortOptions}
                                      onSortedChange={val => {
                                      this.setState({ sortOptions: val }) }}
                                      filterable
                                      noDataText='Loading billing report...'
                                      loading={this.state.loading}
                                      defaultFilterMethod={(filter, row) =>
                                      String(row[filter.id]) === filter.value}          
                                      columns={[
                                        {                                          
                                          columns: [
                                            {
                                              Header: "Order ID",
                                              accessor: "Order Id",
                                              width: 100,
                                              filterable: false,
                                              Cell: row => (
                                                <div style={{ textAlign: "center" }}>{row.value}</div>
                                              )
                                            },                              
                                            {
                                              Header: "First Name/Company",
                                              accessor: "First Name/Company",
                                              width: 175,
                                              show: false,                                              
                                              filterMethod: (filter, row) =>
                                                row[filter.id] !== null ? String(row[filter.id].toLowerCase()).startsWith(filter.value.toLowerCase()) : true                                                     
                                            },
                                            {
                                              Header: "Last Name/Attention",
                                              accessor: "Last Name/Attention",
                                              width: 175,
                                              show: false,
                                              filterMethod: (filter, row) =>
                                                row[filter.id] !== null ? String(row[filter.id].toLowerCase()).startsWith(filter.value.toLowerCase()) : true                                                     
                                            }, 
                                            {
                                              Header: () => (
                                                <div style={{ textAlign: "center" }}>Zip</div>
                                              ),
                                              accessor: "or_zip",
                                              width: 75,
                                              filterMethod: (filter, row) =>
                                              row[filter.id] !== null ? row[filter.id]==filter.value : true,
                                              Cell: row => (
                                                <div style={{ textAlign: "center" }}>{row.value}</div>
                                              )
                                            },
                                            {
                                              Header: "Order Date",
                                              accessor: "or_date",
                                              width: 150,
                                              filterMethod: (filter, row) =>
                                                row[filter.id].startsWith(filter.value),
                                              Cell: row => (
                                                <div style={{ textAlign: "center" }}>{moment(row.value).format("MM-DD-YYYY hh:mm:ss a")}</div>
                                              )
                                            },
                                            {
                                              Header: () => (
                                                <div style={{ textAlign: "center" }}>Order Type</div>
                                              ),
                                              accessor: "or_type",
                                              width: 75,
                                              filterMethod: (filter, row) =>
                                              row[filter.id] !== null ? row[filter.id]==filter.value : true,
                                              Cell: row => (
                                                <div style={{ textAlign: "center" }}>{row.value}</div>
                                              )
                                            },
                                            {
                                              Header: () => (
                                                <div style={{ textAlign: "center" }}>Other</div>
                                              ),
                                              accessor: "or_other",
                                              width: 75,
                                              filterMethod: (filter, row) =>
                                              row[filter.id] !== null ? row[filter.id]==filter.value : true,
                                              Cell: row => (
                                                <div style={{ textAlign: "center" }}>{row.value}</div>
                                              )
                                            },                                                      
                                            {
                                              Header: () => (
                                                <div style={{ textAlign: "center" }}>Carrier</div>
                                              ),
                                              accessor: "or_carrier",
                                              width: 75,
                                              filterMethod: (filter, row) =>
                                              row[filter.id] !== null ? row[filter.id]==filter.value : true,
                                              Cell: row => (
                                                <div style={{ textAlign: "center" }}>{row.value}</div>
                                              )
                                            },
                                            {
                                              Header: () => (
                                                <div style={{ textAlign: "center" }}>Service</div>
                                              ),
                                              accessor: "or_carrier_service",
                                              width: 75,
                                              filterMethod: (filter, row) =>
                                              row[filter.id] !== null ? row[filter.id]==filter.value : true,
                                              Cell: row => (
                                                <div style={{ textAlign: "center" }}>{row.value}</div>
                                              )
                                            },
                                            {
                                              Header: () => (
                                                <div style={{ textAlign: "center" }}>BOL</div>
                                              ),
                                              accessor: "sh_bol",
                                              width: 75,
                                              filterMethod: (filter, row) =>
                                              row[filter.id] !== null ? row[filter.id]==filter.value : true,
                                              Cell: row => (
                                                <div style={{ textAlign: "center" }}>{row.value}</div>
                                              )
                                            },
                                            {
                                              Header: "Shipment Date",
                                              accessor: "sh_date",
                                              width: 150,
                                              filterMethod: (filter, row) =>
                                                row[filter.id].startsWith(filter.value),
                                              Cell: row => (
                                                <div style={{ textAlign: "center" }}>{moment(row.value).format("MM-DD-YYYY hh:mm:ss a")}</div>
                                              )
                                            },
                                            {
                                              Header: () => (
                                                <div style={{ textAlign: "center" }}>Tracking Num</div>
                                              ),
                                              accessor: "sh_tracking",
                                              width: 100,
                                              filterMethod: (filter, row) =>
                                              row[filter.id] !== null ? row[filter.id]==filter.value : true,
                                              Cell: row => (
                                                <div style={{ textAlign: "center" }}>{row.value}</div>
                                              )
                                            },
                                            {
                                              Header: () => (
                                                <div style={{ textAlign: "center" }}>Ship Method</div>
                                              ),
                                              accessor: "or_ship_method",
                                              width: 125,
                                              show: false,
                                              filterMethod: (filter, row) =>
                                              row[filter.id] !== null ? row[filter.id]==filter.value : true,
                                              Cell: row => (
                                                <div style={{ textAlign: "center" }}>{row.value}</div>
                                              )
                                            },
                                            {
                                              Header: () => (
                                                <div style={{ textAlign: "center" }}>Orig Ship Cost</div>
                                              ),
                                              accessor: "orig_ship_cost",
                                              width: 100,
                                              filterMethod: (filter, row) =>
                                              row[filter.id] !== null ? row[filter.id]==filter.value : true,
                                              Cell: row => (
                                                <div style={{ textAlign: "center" }}>{row.value}</div>
                                              )
                                            }, 
                                            {
                                              Header: () => (
                                                <div style={{ textAlign: "center" }}>Adj Ship Cost</div>
                                              ),
                                              accessor: "adjusted_ship_cost",
                                              width: 100,
                                              filterMethod: (filter, row) =>
                                              row[filter.id] !== null ? row[filter.id]==filter.value : true,
                                              Cell: row => (
                                                <div style={{ textAlign: "center" }}>{row.value}</div>
                                              )
                                            },
                                            {
                                              Header: () => (
                                                <div style={{ textAlign: "center" }}>Order Item Count</div>
                                              ),
                                              accessor: "order_item_count",
                                              width: 75,
                                              filterMethod: (filter, row) =>
                                              row[filter.id] !== null ? row[filter.id]==filter.value : true,
                                              Cell: row => (
                                                <div style={{ textAlign: "center" }}>{row.value}</div>
                                              )
                                            },
                                            {
                                              Header: () => (
                                                <div style={{ textAlign: "center" }}>Total Weight</div>
                                              ),
                                              accessor: "total_order_weight",
                                              width: 75,
                                              filterMethod: (filter, row) =>
                                              row[filter.id] !== null ? row[filter.id]==filter.value : true,
                                              Cell: row => (
                                                <div style={{ textAlign: "center" }}>{row.value}</div>
                                              )
                                            }
                                          ]
                                        }
                                      ]}
                                      defaultPageSize={50}
                                      className="-striped -highlight"
                                      
                                    />
                               
                                </div>
                            </div>
                       
                    </div>
                </div>               
                <div className="row">   
                    <div className="col-lg-4">
                       
                    </div>
                </div>


            </div>
        </div>
        </div>

                )
    }
}
export default BillingReport;